import React, { PureComponent } from 'react'

export class FolhaESocial extends PureComponent {
  render() {
    return (
      <div>FolhaESocial</div>
    )
  }
}

export default FolhaESocial